document.addEventListener('DOMContentLoaded', function () {
  const items = document.querySelectorAll('.sake__faq .faq__item');

  items.forEach((item) => {
    item.addEventListener('toggle', function () {
      if (this.open) {
        items.forEach((other) => {
          if (other !== this) {
            other.removeAttribute('open');
          }
        });
      }
    });
  });
});